import { ArrowBack } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { postStoreOneDrug } from "../../../api/group";
import FormDrug from "./formDrug";
import Uploader from "./uploader";

export default function NewDrug({ setMode }) {
  const [selectType, setSelectType] = useState(0);
  const [date, setDate] = useState();

  const [dataForm, setDataForm] = useState({
    name: "",
    producer: "",
    expireAt: "",
    location: "MAIN",
    drugType: "TAB",
    available: "",
    availablePack: "",
    price: "",
    shelfNo: "",
    boxNo: "",
    dose: "",
  });

  return (
    <Box>
      <Box
        display={"flex"}
        alignItems="center"
        justifyContent={"space-between"}
      >
        <Typography mb="20px" className="title_GroupOnline">
          {"داروی جدید"}
        </Typography>
        <Box
          sx={{
            cursor: "pointer",
            color: "var(--emr-darkblue)",
          }}
          onClick={() => {
            setMode("table");
          }}
        >
          <ArrowBack />
        </Box>
      </Box>
      <Box
        borderRadius="10px"
        bgcolor={"white"}
        width={"fit-content"}
        p="5px"
        display={"flex"}
        gap="3px"
        sx={{ cursor: "pointer" }}
      >
        <Box
          borderRadius="0px 10px 10px 0px"
          bgcolor={selectType === 0 ? "var(--emr-primary)" : "white"}
          p="5px 10px"
          color={selectType === 0 ? "white" : "black"}
          sx={{ transition: "0.3s all" }}
          onClick={() => setSelectType(0)}
        >
          افزودن تکی
        </Box>
        <Box
          borderRadius="10px 0px 0px 10px"
          bgcolor={selectType === 1 ? "var(--emr-primary)" : "white"}
          p="5px 10px"
          color={selectType === 1 ? "white" : "black"}
          sx={{ transition: "0.3s all" }}
          onClick={() => setSelectType(1)}
        >
          افزودن گروهی
        </Box>
      </Box>
      {selectType === 0 && (
        <Box
          mt="20px"
          border="solid 2px #6C8C97 "
          borderRadius={"13px"}
          width={"calc( 100% - 40px )"}
          p="40px 20px"
        >
          <FormDrug
            dataForm={dataForm}
            setDataForm={setDataForm}
            date={date}
            setDate={setDate}
          />
          <Box mt="20px" gap="10px" display={"flex"}>
            <Button
              variant="contained"
              style={{
                width: "100px",
              }}
              onClick={() => {
                postStoreOneDrug(dataForm)
                  .then(() => {
                    setMode("table");
                  })
                  .catch(() => {});
              }}
            >
              ثبت دارو
            </Button>
          </Box>
        </Box>
      )}
      {selectType === 1 && (
        <Box>
          <Uploader setMode={setMode} />
        </Box>
      )}
    </Box>
  );
}
